"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _RadialGauge = require("./RadialGauge.styled");

var _Theme = require("../Themes/Theme");

var _text = require("@visx/text");

var _DrawRadialGaugeLayer = _interopRequireDefault(require("../Shared/DrawRadialGaugeLayer"));

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["theme", "sortByValue", "startAngle", "endAngle", "padAngle", "innerRadius", "cornerRadius", "colors", "borderWidth", "enableSliceLabels", "enableRadialLabels", "total", "datum", "statistic", "labelFontSize", "valueFontSize"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function RadialGauge(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _Theme.StyledTheme : _ref$theme,
      _ref$sortByValue = _ref.sortByValue,
      sortByValue = _ref$sortByValue === void 0 ? false : _ref$sortByValue,
      _ref$startAngle = _ref.startAngle,
      startAngle = _ref$startAngle === void 0 ? 0 : _ref$startAngle,
      _ref$endAngle = _ref.endAngle,
      endAngle = _ref$endAngle === void 0 ? 180 : _ref$endAngle,
      _ref$padAngle = _ref.padAngle,
      padAngle = _ref$padAngle === void 0 ? 0 : _ref$padAngle,
      _ref$innerRadius = _ref.innerRadius,
      innerRadius = _ref$innerRadius === void 0 ? 0.9 : _ref$innerRadius,
      _ref$cornerRadius = _ref.cornerRadius,
      cornerRadius = _ref$cornerRadius === void 0 ? 45 : _ref$cornerRadius,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? [theme.radialGauge.colors.datum, theme.radialGauge.colors.empty] : _ref$colors,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth,
      _ref$enableSliceLabel = _ref.enableSliceLabels,
      enableSliceLabels = _ref$enableSliceLabel === void 0 ? false : _ref$enableSliceLabel,
      _ref$enableRadialLabe = _ref.enableRadialLabels,
      enableRadialLabels = _ref$enableRadialLabe === void 0 ? false : _ref$enableRadialLabe,
      _ref$total = _ref.total,
      total = _ref$total === void 0 ? null : _ref$total,
      _ref$datum = _ref.datum,
      datum = _ref$datum === void 0 ? null : _ref$datum,
      _ref$statistic = _ref.statistic,
      statistic = _ref$statistic === void 0 ? null : _ref$statistic,
      _ref$labelFontSize = _ref.labelFontSize,
      labelFontSize = _ref$labelFontSize === void 0 ? '0.875rem' : _ref$labelFontSize,
      _ref$valueFontSize = _ref.valueFontSize,
      valueFontSize = _ref$valueFontSize === void 0 ? '2.625rem' : _ref$valueFontSize,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)({
    toggleScale: false,
    storedWidth: 0
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      valueScaleToFit = _useState2[0],
      setValueScaleToFit = _useState2[1];

  var _useState3 = (0, _react.useState)({
    toggleScale: false,
    multiLine: false,
    storedWidth: 0
  }),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      labelScaleToFit = _useState4[0],
      setLabelScaleToFit = _useState4[1];

  return (0, _jsxRuntime.jsx)(_RadialGauge.StyledRadialGauge, _objectSpread({
    data: [datum],
    theme: theme,
    colors: colors,
    sortByValue: sortByValue,
    startAngle: startAngle,
    endAngle: datum.value / total * 360,
    padAngle: padAngle,
    innerRadius: innerRadius,
    cornerRadius: cornerRadius,
    borderWidth: borderWidth,
    fit: false,
    layers: [function (data) {
      var strokeWidth = 8;
      var radius = data.radius;
      return (0, _jsxRuntime.jsxs)("g", {
        transform: "translate(".concat(data.centerX, ",").concat(data.centerY, ")"),
        children: [(0, _jsxRuntime.jsx)("circle", {
          cx: 0,
          cy: 0,
          r: radius,
          stroke: colors[1],
          strokeWidth: strokeWidth,
          fill: "none"
        }), (0, _jsxRuntime.jsx)(_DrawRadialGaugeLayer["default"], {
          id: props.id,
          data: [data.dataWithArc[0].data],
          value: props.value,
          valueFormat: props.valueFormat,
          colors: colors[0],
          radius: radius + 4,
          innerRadius: radius - 4,
          startAngle: 0,
          endAngle: datum.value / total * 360,
          padAngle: padAngle,
          sortByValue: sortByValue,
          cornerRadius: cornerRadius,
          showTooltip: false
        })]
      });
    }, function (data) {
      return (0, _jsxRuntime.jsxs)("g", {
        transform: "translate(".concat(data.centerX, ",").concat(data.centerY + 15, ")"),
        children: [(0, _jsxRuntime.jsx)(_text.Text, {
          x: 0,
          y: valueScaleToFit.toggleScale ? data.radius - data.radius * 2 * 0.7 : -40,
          dy: labelScaleToFit.multiLine ? -5 : 0,
          textAnchor: "middle",
          verticalAnchor: "middle",
          scaleToFit: labelScaleToFit.toggleScale,
          width: data.radius * 2 - 80,
          innerRef: function innerRef(ref) {
            if (ref) {
              var width = data.innerRadius * 2 - 80;

              if (ref && !labelScaleToFit.toggleScale && !labelScaleToFit.multiLine && ref.children[0].children.length > 1) {
                setLabelScaleToFit({
                  toggleScale: false,
                  multiLine: true
                });
              }

              if (ref && labelScaleToFit.multiLine && !labelScaleToFit.toggleScale && (ref.children[0].children.length > 3 || ref.getBBox().width >= width)) {
                setLabelScaleToFit({
                  toggleScale: true,
                  multiLine: false,
                  storedWidth: ref.getBBox().width
                });
              }

              if (labelScaleToFit.toggleScale && width >= labelScaleToFit.storedWidth) {
                setLabelScaleToFit({
                  toggleScale: false
                });
              }
            }
          },
          style: {
            color: 'rgb(112, 112, 120)',
            fontSize: labelFontSize,
            fontWeight: 400,
            letterSpacing: '-0.006rem'
          },
          children: statistic && statistic.label ? statistic.label : data.dataWithArc[0].label
        }), (0, _jsxRuntime.jsx)(_text.Text, {
          x: 0,
          y: 0,
          textAnchor: "middle",
          verticalAnchor: "middle",
          scaleToFit: valueScaleToFit.toggleScale,
          innerRef: function innerRef(ref) {
            if (ref) {
              var width = data.innerRadius * 2 - 20;

              if (!valueScaleToFit.toggleScale && ref.getBBox().width >= width) {
                setValueScaleToFit({
                  toggleScale: true,
                  storedWidth: ref.getBBox().width
                });
              }

              if (valueScaleToFit.toggleScale && width >= valueScaleToFit.storedWidth) {
                setValueScaleToFit({
                  toggleScale: false
                });
              }
            }
          },
          width: data.radius * 2 - 40,
          style: {
            color: 'rgb(40, 40, 50)',
            fontSize: valueFontSize,
            fontWeight: 300,
            letterSpacing: '-0.022rem'
          },
          children: statistic && statistic.value ? statistic.value : data.dataWithArc[0].formattedValue
        })]
      });
    }],
    enableSliceLabels: enableSliceLabels,
    enableRadialLabels: enableRadialLabels
  }, props));
}

RadialGauge.defaultProps = {};
RadialGauge.displayName = 'RadialGauge';
var _default = RadialGauge;
exports["default"] = _default;